import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
 
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
//import pckg from '../../package.json';

import { MatDialog } from '@angular/material';
import { PopupComponent } from '../app/paginas/popup/popup.component';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

//const googAPIKEY = 'AIzaSyDaRK21a8gWU-AqUVklPty8DkknFhc_Hfs'
//--> Cambio a variables publicas para hacerlo dinámico

@Injectable({
  providedIn: 'root'
})
export class DataService {
 
private myHost = this.infoHostClient();;
 private myPort = '6009';

 //>> QA DVD (homo) > 189.210.202.247:
 //private myHost = '189.210.202.247';

 //>> QA DVD (interna) > 10.48.7.41:
 //private myHost = '10.48.7.41';

 private urlAlive = 'http://' + this.myHost + ':' + this.myPort + '/xp/alive';
 private urlFnFileExist = 'http://' + this.myHost + ':' + this.myPort + '/fn/fileExist';
 private urlG = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysg';
 private urlK = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysk';
 private urlR = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysr';
 private urlMail = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysmail';
 private urlMailRec = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailrec';
 private urlMailPba = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailpba';
 private urlMailAviso = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailaviso';
 private urlMailSinies = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailsinies';
 private urlMenu = 'http://' + this.myHost + ':' + this.myPort + '/xp/menu';
 private urlMenu2 = 'http://' + this.myHost + ':' + this.myPort + '/xp/menu2';
 private urlMenUser = 'http://' + this.myHost + ':' + this.myPort + '/xp/menUser';
 private urlLogin = 'http://' + this.myHost + ':' + this.myPort + '/xp/login';
 private urlValidaCto = 'http://' + this.myHost + ':' + this.myPort + '/xp/validaCto';
 private urlValidaCtoGes = 'http://' + this.myHost + ':' + this.myPort + '/xpGes/validaCtoGes';

 private urlUsrExist = 'http://' + this.myHost + ':' + this.myPort + '/xp/usrExist'; 
 private urlUser = 'http://' + this.myHost + ':' + this.myPort + '/xp/user';
 private urlUserMax = 'http://' + this.myHost + ':' + this.myPort + '/xp/userMax';
 private urlUsers = 'http://' + this.myHost + ':' + this.myPort + '/xp/users';
 private urlUserUpd = 'http://' + this.myHost + ':' + this.myPort + '/xp/userUpd';
 private urlUserIns = 'http://' + this.myHost + ':' + this.myPort + '/xp/userIns';
 private urlConfigMailIns = 'http://' + this.myHost + ':' + this.myPort + '/xp/configMailIns';
 private urlConfigMailUpd = 'http://' + this.myHost + ':' + this.myPort + '/xp/configMailUpd';
 
 private urlSATRegimen = 'http://' + this.myHost + ':' + this.myPort + '/xp/satRegimen';
 private urlSATTipoFactura = 'http://' + this.myHost + ':' + this.myPort + '/xp/satTipoFactura';
 private urlSATUso = 'http://' + this.myHost + ':' + this.myPort + '/xp/satUso';
 private urlSATMoneda = 'http://' + this.myHost + ':' + this.myPort + '/xp/satMoneda';
 private urlSATForma = 'http://' + this.myHost + ':' + this.myPort + '/xp/satForma';
 private urlSATMetodo = 'http://' + this.myHost + ':' + this.myPort + '/xp/satMetodo';
 private urlElemFormatoImp = 'http://' + this.myHost + ':' + this.myPort + '/xp/elemFormImp';
 private urlFormatoImp = 'http://' + this.myHost + ':' + this.myPort + '/xp/formatoImp';
 private urlFormatoFacturaImp = 'http://' + this.myHost + ':' + this.myPort + '/xp/formatoFacturaImp';
 private urlFormStyles = 'http://' + this.myHost + ':' + this.myPort + '/xp/formatoStyles';
 
 private urlGetBases = 'http://' + this.myHost + ':' + this.myPort + '/xp/getBases';
 private urlGetFinanciera = 'http://' + this.myHost + ':' + this.myPort + '/xp/getFinanciera';
 private urlGetGestoraGes = 'http://' + this.myHost + ':' + this.myPort + '/xpGes/getGestoraGes';
 private urlGetOrigenes = 'http://' + this.myHost + ':' + this.myPort + '/xp/getOrigenes';
 private urlGetGenerales = 'http://' + this.myHost + ':' + this.myPort + '/xp/getGenerales';
 private urlGetGeneralesGes = 'http://' + this.myHost + ':' + this.myPort + '/xpGes/getGeneralesGes';
 private urlGetFolios = 'http://' + this.myHost + ':' + this.myPort + '/xp/getFolios';
 private urlGetFoliosGes = 'http://' + this.myHost + ':' + this.myPort + '/xpGes/getFoliosGes';

   
 public sN:string = "searchCFDI";
 public sWe:string = "";
 public sM:string = "";
 public sT1:string = "";
 public sT2:string = "";
 public sWa:string = "";
 public sDe:string = "";
 public sDi:string = "";
 public sDi2:string = "";
 public sTerr:number = 2100;
 public sMailHost = "";
 public sMailFrom = "";
 public sMailU = "";
 public sMailP = "";
 public sMailSSL = "";
 public sMailTSL = "";
 public iteracionWSS;
 public iteracionDisp;
 public navegador;
 public tmpCto = 0;
 public tmpCve = '';

 constructor(
   private http: HttpClient, public dialog: MatDialog
  //private messageService: MessageService
 ) { }

 infoVer(){
   //return pckg.version;
   //  0.0.1  --> 2019/01/01:  Primera versión
   //  0.1.0  --> 2019/02/22:  Se establece la version en meta tag en index.htm y se estandarizo xp/pba y xp/conn
   
   const metas = document.getElementsByTagName('meta');
   var aux = "?";
   //console.log("infoVer()");
   //console.log(metas);
   for (let i = 0; i < metas.length; i++) {
     //console.log(metas[i]);
     if (metas[i].getAttribute('property') === "keywords") {
       aux = metas[i].getAttribute('content');
       i = 999;
     }
   }
   return aux.toUpperCase().replace("VERSION=","");
 }

 infoApp(){
  //console.log(">><><><><><><><><><><><><><><><><><><><><><><><><><><><><<")  
  //console.log(pckg.friendlyname + " (" + pckg.name + ")  ver." + pckg.version);
  //console.log("IP servicio: " + this.myHost + ":" + this.myPort);
  //console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
  //console.log("Desarrollador: "  + pckg.developer + "       « " + pckg.mail + " »");
  //console.log("  " + pckg.copyright);  
  //console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")   
  console.log(">><><><><><><><><><><><><><><><><><><><><><><><><><><><><<")  
  console.log("SEARCH CFDIs" + " (" + "searchcfd" + ")  ver." + this.infoVer());
  console.log("IP servicio: " + this.myHost + ":" + this.myPort);
  console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
  console.log("Desarrollador: "  + "Fabián Orozco" + "       « " + "orozco.f@gmail.com" + " »");
  console.log("            " + "® Copyright 2021 ~ Oro'z Co.");  
  console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")   
}

 infoWebClient(){
  //console.log(window.navigator.userAgent);
  var nav = window.navigator.userAgent.toUpperCase();
  var ver = "?";
  if(nav.indexOf("EDGE/")>0){
    ver = this.encuentraVersion(nav.substr(nav.indexOf("EDGE/") + 5));
    this.navegador = {name: "EDGE", code:"ED", ver: ver};
  }
  else{
    if(nav.indexOf("CHROME/")>0){
      ver = this.encuentraVersion(nav.substr(nav.indexOf("CHROME/") + 7));
      this.navegador = {name: "CHROME", code:"CH", ver:ver};
    }
    else{
      if(nav.indexOf("FIREFOX/")>0){
        ver = this.encuentraVersion(nav.substr(nav.indexOf("FIREFOX/") + 8));
        this.navegador = {name: "FIREFOX", code:"FF", ver:ver};
      }
      else{
        ver = this.encuentraVersion(nav.substr(nav.indexOf("RV:") + 3));
        this.navegador = {name: "IE u OTRO", code:"IE", ver:ver};
      }
    }
  }
  console.log("Usando navegador: " + this.navegador.name + " v." + this.navegador.ver);
  if (this.navegador.code == "IE" ){
    this.fnAvisoNoSoportado();         
  }
  else{
    if(this.navegador.code != "CH" ){
      this.fnAvisoRecomendacion();
    }
  }
 }

 infoHostClient(){
  var url = document.location.href;
  //console.log(url);
  var prehost = url.substr(url.indexOf("://") + 3); 
  var host = prehost.substr(0, prehost.indexOf("/"));
  if(host.indexOf(":") > 0)
   host = host.substr(0, host.indexOf(":"));
  return host;
 }

 infoHostPortClient(){
  var url = document.location.href;
  //console.log(url);
  var prehost = url.substr(url.indexOf("://") + 3); 
  console.log(prehost)
  var hostport = prehost.substr(0, prehost.indexOf("/"));
  return hostport;
}

 encuentraVersion(str){
  var fin, fin2, fin3 = 9999;
  var min = 0;
  fin = str.indexOf(";");
  fin2 = str.indexOf(" ");
  fin3 = str.indexOf(")");
  if(fin < 0)
    fin = 9999;
  if(fin2 < 0)
    fin2 = 9999;
  if(fin3 < 0)
    fin3 = 9999;
  if (fin == 9999  && fin2 == 9999 && fin3 == 9999)
    return str;
  else{
    min = fin;
    if(fin2 < min)
      min = fin2;
    if(fin3 < min)
      min = fin3;
    return str.substr(0, min);
  }
 }

 onlyUnique(value, index, self) { 
  return self.indexOf(value) === index;
}

 trim(str, chars) {
  if(!str)
    str='';
	return this.ltrim(this.rtrim(str.toString().replace('   ',' ').replace('  ',' '), chars), chars);
 }
 
 ltrim(str, chars) {
  if(str==null)
    str="";
	chars = chars || "\s";
	return str.toString().replace(new RegExp("^[" + chars + "]+", "g"), "");
 }
 
 rtrim(str, chars) {
   if(str==null)
    str="";
	chars = chars || "\s";
	return str.toString().replace(new RegExp("[" + chars + "]+$", "g"), "");
 }

 fnFormatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  if(amount == null)
    amount = 0;
  try {
    //console.log(parseFloat(amount).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
    return parseFloat(amount).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  } catch (e) {
    console.log("ERROR:")
    console.log(e)
  }
};


findItemInObject(obj, id_cve_unica, campoIdentificador){
  for(var nitems = 0; nitems < obj.length; nitems++){
    if(obj[nitems][campoIdentificador]  == id_cve_unica)
      return obj[nitems];
  }
}

findItemInObject2Attributes(obj, id_cve1, campoIdentificador1, id_cve2, campoIdentificador2){
 for(var nitems = 0; nitems < obj.length; nitems++){
   if(obj[nitems][campoIdentificador1] == id_cve1 && obj[nitems][campoIdentificador2] == id_cve2)
     return obj[nitems];
 }
}

find(arr, id_valorBuscado, campoBusqueda, campoRetorno){
   //console.log(arr)
   try{
     if(arr[campoBusqueda]){
       let obj = arr.find(o => o[campoBusqueda] === id_valorBuscado);
       return obj[campoRetorno];
     }
     else
       return "-!!-";
   }
   catch(err){
     console.log("ERROR EN find():");
     console.log(arr);
     console.log(id_valorBuscado)
     return "-!-";
   }
}

fnGetHoy(){
  var auxHoy = new Date();
  var year = auxHoy.getFullYear();
  var month = auxHoy.getMonth() + 1;
  var day = auxHoy.getDate();
  var m = "";
  var d = "";
  if(month < 10)
    m = "0" + month;
  else
    m = "" + month;
  if(day < 10)
    d = "0" + day;
  else
    d = "" + day;
  //console.log("HOY: " + year + "-" + m + "-" + d);
  return year + "-" + m + "-" + d;
} 

fnGetAhora(){
  var auxAhora = new Date();
  var hora = auxAhora.getHours();
  var min = auxAhora.getMinutes();
  var seg = auxAhora.getSeconds();
  var h = "";
  var m = "";
  var s = "";
  if(hora < 10)
    h = "0" + hora;
  else
    h = hora.toString();
  if(min < 10)
    m = "0" + min;
  else
    m = min.toString();
  if(seg < 10)
    s = "0" + seg.toString();
  else  
    s = seg.toString();
  //console.log(h + ":" + m + ":" + s)
  return h + ":" + m + ":" + s;
 }

 fnGetDate(strFecha){
   //console.log("Fecha en formato yyyy-mm-dd: " + strFecha);
   var yy = parseInt(strFecha.substr(0,4));
   var mm = parseInt(strFecha.substr(5,2)) - 1;
   var dd = parseInt(strFecha.substr(-2));
   if(mm < 0){
      yy = yy - 1;
      mm = 11
   }   
   var auxDate = new Date(yy, mm, dd);
   return auxDate;
 }

 fnGetDateFormat(strFecha, strFormat){
  //console.log("Fecha en formato yyyy-mm-dd: " + strFecha);
  if(strFecha == undefined || strFecha == null)
    strFecha = "1900-01-01";
  var monthNames = [
    "Enero", "Febrero", "Marzo",
    "Abril", "Mayo", "Junio", "Julio",
    "Agosto", "Septiembre", "Octubre",
    "Noviembre", "Diciembre"
  ]
  var monthAbr = [
    "Ene", "Feb", "Mar",
    "Abr", "May", "Jun", "Jul",
    "Ago", "Sep", "Oct",
    "Nov", "Dic"
  ]
  var yy = parseInt(strFecha.substr(0,4));  
  var mm = parseInt(strFecha.substr(5,2)) - 1;  
  var dd = parseInt(strFecha.substr(8,2)); 
  var auxDate = new Date(yy, mm, dd);
  //console.log("auxDate = " + auxDate);
  //console.log(strFormat);
  var formatDate = ""
  formatDate = "" + parseInt(strFecha.substr(-2)) + "/" + parseInt(strFecha.substr(5,2)) + "/" + yy;
  if(strFormat == "MMDY")
    formatDate = monthNames[mm] + " " + dd + ", " + yy;
  if(strFormat == "DMY")
    formatDate = dd + " / " + monthAbr[mm] + " / " + yy;    
  if(strFormat == "DMMY")
    formatDate = dd + " de " + monthNames[mm] + " de " + yy;    
  if(strFormat == "DMMMY")
    formatDate = dd + " de " + monthAbr[mm] + " de " + yy;
  if(strFormat == "Y-M-D"){
    formatDate =  yy + "-" + strFecha.substr(5,2) + "-" + strFecha.substr(8,2);
  }
  return formatDate.toString();
}


fnLeeMonto(monto){
  console.log(monto);
  if(monto == 0 || monto == undefined)
    return "CERO PESOS (00/100) M.N.";
  //--> Funcion diseñada hasta el número 99,999.99 (5 digitos enteros) < 100K
  var auxInt = Math.trunc(monto);
  var auxDec = Math.round((monto - auxInt)*100);
  var auxDig = "";
  var auxDigSig = "";
  var auxDigSig2 = "";
  var auxTxt = "";
  var salta = false;
  for(var pos = auxInt.toString().length - 1; pos >= 0; pos--){
    if(salta){
      salta = false;
      continue;
    }
    auxDig = auxInt.toString().substr(auxInt.toString().length - pos -1, 1)
    if(pos > 0)
      auxDigSig = auxInt.toString().substr(auxInt.toString().length - pos, 1)
    if(pos > 1)
      auxDigSig2 = auxInt.toString().substr(auxInt.toString().length - pos + 1, 1)
    if(pos == 0){
      if(auxDig=="1")
        auxTxt += "UNO";
      if(auxDig=="2")
        auxTxt += "DOS";
      if(auxDig=="3")
        auxTxt += "TRES";
      if(auxDig=="4")
        auxTxt += "CUATRO";
      if(auxDig=="5")
        auxTxt += "CINCO";
      if(auxDig=="6")
        auxTxt += "SEIS";
      if(auxDig=="7")
        auxTxt += "SIETE";
      if(auxDig=="8")
        auxTxt += "OCHO";
      if(auxDig=="9")
        auxTxt += "NUEVE";
    }    
    if(pos == 1){
      if(auxDig=="3")
        auxTxt += "TREINTA";
      if(auxDig=="4")
        auxTxt += "CUARENTA";
      if(auxDig=="5")
        auxTxt += "CINCUENTA";
      if(auxDig=="6")
        auxTxt += "SESENTA";
      if(auxDig=="7")
        auxTxt += "SETENTA";
      if(auxDig=="8")
        auxTxt += "OCHENTA";
      if(auxDig=="9")
        auxTxt += "NOVENTA";
      if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig != "0")
        auxTxt += " Y ";
      if(auxDig == "1" && auxDigSig== "0"){
        auxTxt += "DIEZ";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "1"){
        auxTxt += "ONCE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "2"){
        auxTxt += "DOCE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "3"){
        auxTxt += "TRECE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "4"){
        auxTxt += "CATORCE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "5"){
        auxTxt += "QUINCE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "6"){
        auxTxt += "DIECISEIS";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "7"){
        auxTxt += "DIECISIETE";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "8"){
        auxTxt += "DIECIOCHO";
        salta = true;
      }
      if(auxDig == "1" && auxDigSig== "9"){
        auxTxt += "DIECINUEVE";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "0"){
        auxTxt += "VEINTE";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "1"){
        auxTxt += "VEINTIUNO";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "2"){
        auxTxt += "VEINTIDOS";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "3"){
        auxTxt += "VEINTITRES";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "4"){
        auxTxt += "VEINTICUATRO";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "5"){
        auxTxt += "VEINTICINCO";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "6"){
        auxTxt += "VEINTISEIS";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "7"){
        auxTxt += "VEINTISIETE";
         salta = true;
      }
      if(auxDig == "2" && auxDigSig== "8"){
        auxTxt += "VEINTIOCHO";
        salta = true;
      }
      if(auxDig == "2" && auxDigSig== "9"){
        auxTxt += "VEINTINUEVE";
        salta = true;
      }
    }    
    if(pos == 2){
      if(auxDig=="2")
        auxTxt += "DOSCIENTOS";
      if(auxDig=="3")
        auxTxt += "TRESCIENTOS";
      if(auxDig=="4")
        auxTxt += "CUATROCIENTOS";
      if(auxDig=="5")
        auxTxt += "QUINIENTOS";
      if(auxDig=="6")
        auxTxt += "SEISCIENTOS";
      if(auxDig=="7")
        auxTxt += "SETECIENTOS";
      if(auxDig=="8")
        auxTxt += "OCHOCIENTOS";
      if(auxDig=="9")
        auxTxt += "NOVECIENTOS";
      if(auxDig == "1" && auxDigSig != "0")
        auxTxt += "CIENTO";
      if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 != "0"){
        auxTxt += "CIENTO";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 == "0"){
        auxTxt += "CIEN";
        salta=true;
      }
    }
    if(pos == 3){
      if(auxDig=="0")
        auxTxt += "MIL";
      if(auxDig=="1")
        auxTxt += "MIL";
      if(auxDig=="2")
        auxTxt += "DOS MIL";
      if(auxDig=="3")
        auxTxt += "TRES MIL";
      if(auxDig=="4")
        auxTxt += "CUATRO MIL";
      if(auxDig=="5")
        auxTxt += "CINCO MIL";
      if(auxDig=="6")
        auxTxt += "SEIS MIL";
      if(auxDig=="7")
        auxTxt += "SIETE MIL";
      if(auxDig=="8")
        auxTxt += "OCHO MIL";
      if(auxDig=="9")
        auxTxt += "NUEVE MIL";
    }
    if(pos == 4){
      if(auxDig=="3")
        auxTxt += "TREINTA";
      if(auxDig=="4")
        auxTxt += "CUARENTA";
      if(auxDig=="5")
        auxTxt += "CINCUENTA";
      if(auxDig=="6")
        auxTxt += "SESENTA";
      if(auxDig=="7")
        auxTxt += "SETENTA";
      if(auxDig=="8")
        auxTxt += "OCHENTA";
      if(auxDig=="9")
        auxTxt += "NOVENTA";
      if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig == "0"){   //--> 11011.13, 31027.13
        auxTxt += " MIL";
        salta=true;
      }
      if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig != "0" && auxDigSig != "1")
        auxTxt += " Y ";
      if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig == "1"){   //--> 11011.13, 31027.13
        auxTxt += " Y UN MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "0"){
        auxTxt += "DIEZ MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "1"){
        auxTxt += "ONCE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "2"){
        auxTxt += "DOCE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "3"){
        auxTxt += "TRECE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "4"){
        auxTxt += "CATORCE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "5"){
        auxTxt += "QUINCE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "6"){
        auxTxt += "DIECISEIS MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "7"){
        auxTxt += "DIECISIETE MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "8"){
        auxTxt += "DIECIOCHO MIL";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig== "9"){
        auxTxt += "DIECINUEVE MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "0"){
        auxTxt += "VEINTE MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "1"){
        auxTxt += "VEINTIUN MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "2"){
        auxTxt += "VEINTIDOS MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "3"){
        auxTxt += "VEINTITRES MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "4"){
        auxTxt += "VEINTICUATRO MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "5"){
        auxTxt += "VEINTICINCO MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "6"){
        auxTxt += "VEINTISEIS MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "7"){
        auxTxt += "VEINTISIETE MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "8"){
        auxTxt += "VEINTIOCHO MIL";
        salta=true;
      }
      if(auxDig == "2" && auxDigSig== "9"){
        auxTxt += "VEINTINUEVE MIL";
        salta=true;
      }
    }    
    if(pos == 5){
      if(auxDig=="2")
        auxTxt += "DOSCIENTOS";
      if(auxDig=="3")
        auxTxt += "TRESCIENTOS";
      if(auxDig=="4")
        auxTxt += "CUATROCIENTOS";
      if(auxDig=="5")
        auxTxt += "QUINIENTOS";
      if(auxDig=="6")
        auxTxt += "SEISCIENTOS";
      if(auxDig=="7")
        auxTxt += "SETECIENTOS";
      if(auxDig=="8")
        auxTxt += "OCHOCIENTOS";
      if(auxDig=="9")
        auxTxt += "NOVECIENTOS";
      if(auxDig == "1" && auxDigSig != "0")
        auxTxt += "CIENTO";
      if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 != "0"){
        auxTxt += "CIENTO";
        salta=true;
      }
      if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 == "0"){
        auxTxt += "CIEN";
        salta=true;
      }
    }
    if(pos == 6){
      if(auxDig=="1")
        auxTxt += "UN MILLON";
      if(auxDig=="2")
        auxTxt += "DOS MILLONES";
      if(auxDig=="3")
        auxTxt += "TRES MILLONES";
      if(auxDig=="4")
        auxTxt += "CUATRO MILLONES";
      if(auxDig=="5")
        auxTxt += "CINCO MILLONES";
      if(auxDig=="6")
        auxTxt += "SEIS MILLONES";
      if(auxDig=="7")
        auxTxt += "SIETE MILLONES";
      if(auxDig=="8")
        auxTxt += "OCHO MILLONES";
      if(auxDig=="9")
        auxTxt += "NUEVE MILLONES";
      if(auxDigSig == "0" ){
          salta=true;
        }
    }
    auxTxt += " ";
  }
  return "" +  auxTxt.replace(/  /g," ") + "PESOS (" + ("0" + auxDec.toString()).substr(-2) + "/100) M.N.";
}

fnGetBase64Image(img, width, height) {
  //console.log("getBase64");
  //console.log(img);
  var canvas = document.createElement("canvas");
  //--> Especificar el ancho deseado: (parametro width)
  canvas.width = width;
  canvas.height = height;
  //--> Para usar el tamaño del control (<img>) no hace falta parametro width:
  //canvas.width = img.width;
  //canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  //return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  return dataURL;
}

fnReplaceSpecialStrings(cadena, arrData){
  var auxCadena = cadena;
  console.log(cadena);
  console.log(arrData);
  if(arrData[0].COL){    //--> SOLO PARA REPORTES!
    //console.log(arrData[0].COL)
    //console.log(arrData[0].COL[0])
    auxCadena = auxCadena.replace(/ƒFILTRO1/g, arrData[0].FILTRO1).replace(/ƒFILTRO2/g, arrData[0].FILTRO2).replace(/ƒFILTRO3/g, arrData[0].FILTRO3);
    auxCadena = auxCadena.replace(/ƒCOL_TIT_0/g, arrData[0].COLTIT[0]);
    auxCadena = auxCadena.replace(/ƒCOL_0/g, arrData[0].COL[0].replace(/ƒ/g,"\n"));
    auxCadena = auxCadena.replace(/ƒCOL_TIT_1/g, arrData[0].COLTIT[1]);
    auxCadena = auxCadena.replace(/ƒCOL_1/g, arrData[0].COL[1].replace(/ƒ/g,"\n"));
    auxCadena = auxCadena.replace(/ƒCOL_TIT_2/g, arrData[0].COLTIT[2]);
    auxCadena = auxCadena.replace(/ƒCOL_2/g, arrData[0].COL[2].replace(/ƒ/g,"\n"));
    auxCadena = auxCadena.replace(/ƒCOL_TIT_3/g, arrData[0].COLTIT[3]);
    auxCadena = auxCadena.replace(/ƒCOL_3/g, arrData[0].COL[3].replace(/ƒ/g,"\n"));
    auxCadena = auxCadena.replace(/ƒCOL_TIT_4/g, arrData[0].COLTIT[4]);
    auxCadena = auxCadena.replace(/ƒCOL_4/g, arrData[0].COL[4].replace(/ƒ/g,"\n"));
    if(arrData[0].COLTIT[5]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_5/g, arrData[0].COLTIT[5]);
      auxCadena = auxCadena.replace(/ƒCOL_5/g, arrData[0].COL[5].replace(/ƒ/g,"\n"));
    }
    if(arrData[0].COLTIT[6]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_6/g, arrData[0].COLTIT[6]);
      auxCadena = auxCadena.replace(/ƒCOL_6/g, arrData[0].COL[6].replace(/ƒ/g,"\n"));
    }
    else{
      auxCadena = auxCadena.replace(/ƒCOL_TIT_6/g, "");      
      auxCadena = auxCadena.replace(/ƒCOL_6/g, "");      
    }
    if(arrData[0].COLTIT[7]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_7/g, arrData[0].COLTIT[7]);
      auxCadena = auxCadena.replace(/ƒCOL_7/g, arrData[0].COL[7].replace(/ƒ/g,"\n"));
    }
    else{
      auxCadena = auxCadena.replace(/ƒCOL_TIT_7/g, "");      
      auxCadena = auxCadena.replace(/ƒCOL_7/g, "");      
    }
    if(arrData[0].COLTIT[8]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_8/g, arrData[0].COLTIT[8]);
      auxCadena = auxCadena.replace(/ƒCOL_8/g, arrData[0].COL[8].replace(/ƒ/g,"\n"));
    }
    else{
      auxCadena = auxCadena.replace(/ƒCOL_TIT_8/g, "");      
      auxCadena = auxCadena.replace(/ƒCOL_8/g, "");      
    }
    if(arrData[0].COLTIT[9]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_9/g, arrData[0].COLTIT[9]);
      auxCadena = auxCadena.replace(/ƒCOL_9/g, arrData[0].COL[9].replace(/ƒ/g,"\n"));
    }
    else{
      auxCadena = auxCadena.replace(/ƒCOL_TIT_9/g, "");      
      auxCadena = auxCadena.replace(/ƒCOL_9/g, "");      
    }
    if(arrData[0].COLTIT[10]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_A/g, arrData[0].COLTIT[10]);
      auxCadena = auxCadena.replace(/ƒCOL_A/g, arrData[0].COL[10].replace(/ƒ/g,"\n"));
    }
    else{
      auxCadena = auxCadena.replace(/ƒCOL_TIT_A/g, "");      
      auxCadena = auxCadena.replace(/ƒCOL_A/g, "");      
    }
    if(arrData[0].COLTIT[11]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_B/g, arrData[0].COLTIT[11]);
      auxCadena = auxCadena.replace(/ƒCOL_B/g, arrData[0].COL[11].replace(/ƒ/g,"\n"));
    }
    if(arrData[0].COLTIT[12]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_C/g, arrData[0].COLTIT[12]);
      auxCadena = auxCadena.replace(/ƒCOL_C/g, arrData[0].COL[12].replace(/ƒ/g,"\n"));
    }    
    if(arrData[0].COLTIT[13]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_D/g, arrData[0].COLTIT[13]);
      auxCadena = auxCadena.replace(/ƒCOL_D/g, arrData[0].COL[13].replace(/ƒ/g,"\n"));
    }
    if(arrData[0].COLTIT[14]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_E/g, arrData[0].COLTIT[14]);
      auxCadena = auxCadena.replace(/ƒCOL_E/g, arrData[0].COL[14].replace(/ƒ/g,"\n"));
    }    
    if(arrData[0].COLTIT[15]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_F/g, arrData[0].COLTIT[15]);
      auxCadena = auxCadena.replace(/ƒCOL_F/g, arrData[0].COL[15].replace(/ƒ/g,"\n"));
    }    
    if(arrData[0].COLTIT[16]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_G/g, arrData[0].COLTIT[16]);
      auxCadena = auxCadena.replace(/ƒCOL_G/g, arrData[0].COL[16].replace(/ƒ/g,"\n"));
    }    
    if(arrData[0].COLTIT[17]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_H/g, arrData[0].COLTIT[17]);
      auxCadena = auxCadena.replace(/ƒCOL_H/g, arrData[0].COL[17].replace(/ƒ/g,"\n"));
    }    
    if(arrData[0].COLTIT[18]){
      auxCadena = auxCadena.replace(/ƒCOL_TIT_I/g, arrData[0].COLTIT[18]);
      auxCadena = auxCadena.replace(/ƒCOL_I/g, arrData[0].COL[18].replace(/ƒ/g,"\n"));
    }    

  }
  auxCadena = auxCadena.replace(/ƒFECHAMMDY/g, this.fnGetDateFormat(this.fnGetHoy(),"MMDY"));
  auxCadena = auxCadena.replace(/ƒFECHADMMY/g, this.fnGetDateFormat(this.fnGetHoy(),"DMMY"));
  auxCadena = auxCadena.replace(/ƒFECHADMY/g, this.fnGetDateFormat(this.fnGetHoy(),"DMY"));
  auxCadena = auxCadena.replace(/ƒHORAHMS/g, this.fnGetAhora()).replace(/ƒFECHACER/g, arrData[0].FECHACER);
  auxCadena = auxCadena.replace(/ƒRAZON/g, arrData[0].RAZON).replace(/ƒALIAS/g, arrData[0].ALIAS).replace(/ƒDOMSUC/g, arrData[0].DOMSUC).replace(/ƒCOLSUC/g, arrData[0].COLSUC).replace(/ƒMUNSUC/g, arrData[0].MUNSUC).replace(/ƒEDOSUC/g, arrData[0].EDOSUC).replace(/ƒWWW/g, arrData[0].WWWGES).replace(/ƒRFCGES/g, arrData[0].RFCGES);
  auxCadena = auxCadena.replace(/ƒCTO/g, arrData[0].CTO).replace(/ƒCVE/g, arrData[0].CVE).replace(/ƒFECHACTO/g, arrData[0].FECHACTO).replace(/ƒFECHALARGACTO/g, arrData[0].FECHALARGACTO).replace(/ƒFECHALARGACAN/g, arrData[0].FECHALARGACAN).replace(/ƒFECHALARGAORI/g, arrData[0].FECHALARGAORI).replace(/ƒCAJERO/g, arrData[0].CAJERO);
  auxCadena = auxCadena.replace(/ƒCTE/g, arrData[0].CTE).replace(/ƒIDNUM/g, arrData[0].IDNUM).replace(/ƒCONCTE/g, arrData[0].CONCTE).replace(/ƒASESOR/g, arrData[0].ASESOR).replace(/ƒCTAS/g, arrData[0].CTAS).replace(/ƒMONTO/g, arrData[0].MONTO);
  auxCadena = auxCadena.replace(/ƒCTA_HOR/g, arrData[0].CTASHOR).replace(/ƒHI/g, arrData[0].HI).replace(/ƒHG/g, arrData[0].HG).replace(/ƒESQ/g, arrData[0].ESQ).replace(/ƒSEGUIM/g, arrData[0].SEGUIM);
  auxCadena = auxCadena.replace(/ƒRFCCTE/g, arrData[0].RFCCTE).replace(/ƒCURPCTE/g, arrData[0].CURPCTE).replace(/ƒDOMCTE/g, arrData[0].DOMCTE).replace(/ƒDOMCT2/g, arrData[0].DOMCT2).replace(/ƒEDOCIVCTE/g, arrData[0].EDOCIVCTE);
  auxCadena = auxCadena.replace(/ƒEDOCTE/g, arrData[0].EDOCTE).replace(/ƒMUNCTE/g, arrData[0].MUNCTE).replace(/ƒCOLCTE/g, arrData[0].COLCTE).replace(/ƒCPCTE/g, arrData[0].CPCTE);
  auxCadena = auxCadena.replace(/ƒTELCTE/g, arrData[0].TELCTE).replace(/ƒTELOFICTE/g, arrData[0].TELOFICTE).replace(/ƒCELCTE/g, arrData[0].CELCTE).replace(/ƒMAILCTE/g, arrData[0].MAILCTE);
  auxCadena = auxCadena.replace(/ƒEMPCTE/g, arrData[0].EMPCTE).replace(/ƒPTOCTE/g, arrData[0].PTOCTE).replace(/ƒANTCTE/g, arrData[0].ANTCTE).replace(/ƒTIPINGCTE/g, arrData[0].TIPINGCTE);
  auxCadena = auxCadena.replace(/ƒINGMES/g, arrData[0].INGMES).replace(/ƒOTROING/g, arrData[0].OTROING).replace(/ƒFUENTE/g, arrData[0].FUENTE)
  auxCadena = auxCadena.replace(/ƒn/g, "\n").replace(/ƒVIÑETA/g, "\u00BB").replace(/ƒt/g, "\t");
  auxCadena = auxCadena.replace(/ƒBCSI/g, arrData[0].BCSI).replace(/ƒBCNO/g, arrData[0].BCNO).replace(/ƒTITULO/g, arrData[0].TITULO).replace(/ƒNOTA/g, arrData[0].NOTA);
  auxCadena = auxCadena.replace(/ƒAPPBEN1/g, arrData[0].APPBEN1).replace(/ƒAPPBEN2/g, arrData[0].APPBEN2).replace(/ƒAPPBEN3/g, arrData[0].APPBEN3).replace(/ƒAPPBEN4/g, arrData[0].APPBEN4);
  auxCadena = auxCadena.replace(/ƒAPMBEN1/g, arrData[0].APMBEN1).replace(/ƒAPMBEN2/g, arrData[0].APMBEN2).replace(/ƒAPMBEN3/g, arrData[0].APMBEN3).replace(/ƒAPMBEN4/g, arrData[0].APMBEN4);
  auxCadena = auxCadena.replace(/ƒNOMBEN1/g, arrData[0].NOMBEN1).replace(/ƒNOMBEN2/g, arrData[0].NOMBEN2).replace(/ƒNOMBEN3/g, arrData[0].NOMBEN3).replace(/ƒNOMBEN4/g, arrData[0].NOMBEN4);
  auxCadena = auxCadena.replace(/ƒPARBEN1/g, arrData[0].PARBEN1).replace(/ƒPARBEN2/g, arrData[0].PARBEN2).replace(/ƒPARBEN3/g, arrData[0].PARBEN3).replace(/ƒPARBEN4/g, arrData[0].PARBEN4);
  auxCadena = auxCadena.replace(/ƒPORBEN1/g, arrData[0].PORBEN1).replace(/ƒPORBEN2/g, arrData[0].PORBEN2).replace(/ƒPORBEN3/g, arrData[0].PORBEN3).replace(/ƒPORBEN4/g, arrData[0].PORBEN4);
  auxCadena = auxCadena.replace(/ƒPLAZODIAS/g, arrData[0].PLAZODIAS).replace(/ƒEDAD/g, arrData[0].EDAD).replace(/ƒSTATUS/g, arrData[0].STATUS);
  auxCadena = auxCadena.replace(/ƒFOLIO/g, arrData[0].FOLIO).replace(/ƒTMKCVE/g, arrData[0].TMKCVE).replace(/ƒTMKFEC/g, arrData[0].TMKFEC).replace(/ƒEFECTO/g, arrData[0].EFECTO);
  auxCadena = auxCadena.replace(/ƒTMKHORA/g, arrData[0].TMKHORA).replace(/ƒTMKCAL/g, arrData[0].TMKCAL).replace(/ƒTMKMEDIO/g, arrData[0].TMKMEDIO).replace(/ƒTARS/g, arrData[0].TARS);
  auxCadena = auxCadena.replace(/ƒTARJPROD/g, arrData[0].TARJPROD).replace(/ƒTARJTER/g, arrData[0].TARJTER).replace(/ƒTARJFECVEN/g, arrData[0].TARJFECVEN).replace(/ƒTARJCONCEP/g, arrData[0].TARJCONCEP)
  auxCadena = auxCadena.replace(/ƒTARJMONTO/g, arrData[0].TARJMONTO).replace(/ƒTARJLETRAMONTO/g, arrData[0].TARJLETRAMONTO).replace(/ƒRFCPAC/g, arrData[0].RFCPAC).replace(/ƒCERTPAC/g, arrData[0].CERTPAC)
  auxCadena = auxCadena.replace(/ƒGESCLABE/g, arrData[0].GESCLABE).replace(/ƒGESBANCO/g, arrData[0].GESBANCO).replace(/ƒSELLOCFDI/g, arrData[0].SELLOCFDI).replace(/ƒSELLOSAT/g, arrData[0].SELLOSAT)
  auxCadena = auxCadena.replace(/ƒSATCADENA/g, arrData[0].SATCADENA).replace(/ƒSATMONEDA/g, arrData[0].SATMONEDA).replace(/ƒSATFORMA/g, arrData[0].SATFORMA).replace(/ƒSATMETODO/g, arrData[0].SATMETODO).replace(/ƒTRASLADOS/g, arrData[0].TRASLADOS).replace(/ƒRETENCIONES/g, arrData[0].RETENCIONES).replace(/ƒSUBTOTAL/g, arrData[0].SUBTOTAL)
  auxCadena = auxCadena.replace(/ƒQTY1/g, arrData[0].QTY1).replace(/ƒSATCVE1/g, arrData[0].SATCVE1).replace(/ƒSATUNI1/g, arrData[0].SATUNI1).replace(/ƒSATCONCEP1/g, arrData[0].SATCONCEP1).replace(/ƒSATVAL1/g, arrData[0].SATVAL1).replace(/ƒSATIMP1/g, arrData[0].SATIMP1)
  auxCadena = auxCadena.replace(/ƒQTY2/g, arrData[0].QTY2).replace(/ƒSATCVE2/g, arrData[0].SATCVE2).replace(/ƒSATUNI2/g, arrData[0].SATUNI2).replace(/ƒSATCONCEP2/g, arrData[0].SATCONCEP2).replace(/ƒSATVAL2/g, arrData[0].SATVAL2).replace(/ƒSATIMP2/g, arrData[0].SATIMP2)
  auxCadena = auxCadena.replace(/ƒQTY3/g, arrData[0].QTY3).replace(/ƒSATCVE3/g, arrData[0].SATCVE3).replace(/ƒSATUNI3/g, arrData[0].SATUNI3).replace(/ƒSATCONCEP3/g, arrData[0].SATCONCEP3).replace(/ƒSATVAL3/g, arrData[0].SATVAL3).replace(/ƒSATIMP3/g, arrData[0].SATIMP3)
  auxCadena = auxCadena.replace(/ƒQTY4/g, arrData[0].QTY4).replace(/ƒSATCVE4/g, arrData[0].SATCVE4).replace(/ƒSATUNI4/g, arrData[0].SATUNI4).replace(/ƒSATCONCEP4/g, arrData[0].SATCONCEP4).replace(/ƒSATVAL4/g, arrData[0].SATVAL4).replace(/ƒSATIMP4/g, arrData[0].SATIMP4)
  auxCadena = auxCadena.replace(/ƒQTY5/g, arrData[0].QTY5).replace(/ƒSATCVE5/g, arrData[0].SATCVE5).replace(/ƒSATUNI5/g, arrData[0].SATUNI5).replace(/ƒSATCONCEP5/g, arrData[0].SATCONCEP5).replace(/ƒSATVAL5/g, arrData[0].SATVAL5).replace(/ƒSATIMP5/g, arrData[0].SATIMP5)
  auxCadena = auxCadena.replace(/ƒQTY6/g, arrData[0].QTY6).replace(/ƒSATCVE6/g, arrData[0].SATCVE6).replace(/ƒSATUNI6/g, arrData[0].SATUNI6).replace(/ƒSATCONCEP6/g, arrData[0].SATCONCEP6).replace(/ƒSATVAL6/g, arrData[0].SATVAL6).replace(/ƒSATIMP6/g, arrData[0].SATIMP6)
  auxCadena = auxCadena.replace(/ƒQTY7/g, arrData[0].QTY7).replace(/ƒSATCVE7/g, arrData[0].SATCVE7).replace(/ƒSATUNI7/g, arrData[0].SATUNI7).replace(/ƒSATCONCEP7/g, arrData[0].SATCONCEP7).replace(/ƒSATVAL7/g, arrData[0].SATVAL7).replace(/ƒSATIMP7/g, arrData[0].SATIMP7)
  auxCadena = auxCadena.replace(/ƒQTY8/g, arrData[0].QTY8).replace(/ƒSATCVE8/g, arrData[0].SATCVE8).replace(/ƒSATUNI8/g, arrData[0].SATUNI8).replace(/ƒSATCONCEP8/g, arrData[0].SATCONCEP8).replace(/ƒSATVAL8/g, arrData[0].SATVAL8).replace(/ƒSATIMP8/g, arrData[0].SATIMP8)
  auxCadena = auxCadena.replace(/ƒACCION/g, arrData[0].ACCION).replace(/ƒAXION/g, arrData[0].AXION).replace(/ƒREESCTO/g, arrData[0].REESCTO).replace(/ƒDEVMONTO/g, arrData[0].DEVMONTO).replace(/ƒDEVLETRAMONTO/g, arrData[0].DEVLETRAMONTO).replace(/ƒHONOLETRAMONTO/g, arrData[0].HONOLETRAMONTO).replace(/ƒREESMONTO/g, arrData[0].REESMONTO).replace(/ƒREESLETRAMONTO/g, arrData[0].REESLETRAMONTO).replace(/ƒCTLETRAMONTO/g, arrData[0].CTLETRAMONTO)
  auxCadena = auxCadena.replace(/ƒFECHAREES/g, arrData[0].FECHAREES).replace(/ƒFECHACAN/g, arrData[0].FECHACAN).replace(/ƒREESVIG/g, arrData[0].REESVIG).replace(/ƒNUMPAGOS/g, arrData[0].NUMPAGOS).replace(/ƒPAGOSMONTO/g, arrData[0].PAGOSMONTO).replace(/ƒPAGOLETRAMONTO/g, arrData[0].PAGOLETRAMONTO)
  auxCadena = auxCadena.replace(/ƒDEPTES/g, arrData[0].DEPTES).replace(/ƒESCOLAR/g, arrData[0].ESCOLAR)
  // ƒPAGOS
  return auxCadena
}

 fnAvisoNoSoportado(){
  console.log("NO SOPORTADO !");
  setTimeout(() => {
      let dialogRef = this.dialog.open(PopupComponent, {
        width: '520px',
        data: { 
          timer: 15,
          titulo: "Atención",
          texto1: `Este navegador no cumple con los estandares HTML5/CSS3.`,
          texto2: `El sitio opera bajo los estándares HTML5/CSS3 por lo que éste navegador
                  no es soportado.`,
          texto3: `Utilice el navegador "Chrome" para visualizar el sitio; también están soportados 
                  los navegadores "Firefox" y "Edge" `  
              }
      });
    }, 1000);
 }

 fnAvisoRecomendacion(){
  console.log("SE RECOMIENDA EL USO DE CHROME")
  //alert("RECOMENDAMOS CHROME")
  setTimeout(() => {
    let dialogRef = this.dialog.open(PopupComponent, {
      width: '520px',
      data: { 
        timer: 15,
        titulo: "Atención",
        texto1: `Algunas de las funcionalidades del sitio no han sido revisadas en éste navegador.`,
        texto2: `Para asegurar la experiencia 
                 del usuario, recomendamos utilizar el navegador "Chrome".`,
        texto3: ` 
                `  
            }
    });
  }, 1000);  
 }

 validKey(t,e){
        //console.log(t);
        //console.log(e.charCode);
         var esBorradoFlechaTab = false;
         var esNumero = false;
         var esLetraMinuscula = false;
         var esLetraMayuscula = false;
         var esAcentoMinuscula = false;
         var esAcentoMayuscula = false;
         var esEspacio = false;
         var esEnter = false;
         if(e.key=="Dead"){
           return false;
         }
         //if(e.charCode==46 || e.charCode==8 || e.charCode==37 || e.charCode==39 || e.charCode==9) //--> NO USAR SOLO CHARCODE!! ya que significan otra cosa
         if(e.key=="Delete" || e.key=="Backspace" || e.key=="ArrowLeft" || e.key=="ArrowRight" || e.key=="Tab")
           esBorradoFlechaTab = true;
         if(e.charCode >= 48 && e.charCode <= 57)
           esNumero = true;
         if((e.charCode  >= 65 && e.charCode  <= 90) || e.key == 'Ñ' || e.charCode == 209)
           esLetraMayuscula = true;
         if((e.charCode  >= 97 && e.charCode  <= 122 && e.key != "+") || e.key == 'ñ' || e.charCode == 241)
           esLetraMinuscula = true;  
         if(e.key == 'Á' || e.charCode == 193 || e.key == 'É' || e.charCode == 201 || e.key == 'Í' || e.charCode == 205 || e.key == 'Ó' || e.charCode == 211 || e.key == 'Ú' || e.charCode == 218)
           esAcentoMayuscula = true;
         if(e.key == 'á' || e.charCode == 225 || e.key == 'é' || e.charCode == 233 || e.key == 'í' || e.charCode == 237 || e.key == 'ó' || e.charCode == 243 || e.key == 'ú' || e.charCode == 250)
           esAcentoMinuscula = true; 
         if(e.key == ' ' || e.charCode==32)
           esEspacio=true;
         if(e.key == 'Enter' || e.charCode==13)
           esEnter=true;
     
         if(t=='NUMERO' || t=='TEL'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter)
               return false;           
         }
         if(t=='DECIMAL'){
          if(!esBorradoFlechaTab && !esNumero && !esEnter){
            if(e.key=="." || e.charCode==46 || e.key=="_" || e.charCode==95)
              return true;
            else
              return false;
          }
        }
        if(t=='PTO'){
          if(!esBorradoFlechaTab && !esNumero && !esEnter){
            if(e.key=="_" || e.charCode==95)
              return true;
            else
              return false;            
          }
        }
        if(t=='IP'){
          if(!esBorradoFlechaTab && !esNumero && !esEnter){
            if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95)
              return true;
            else
              return false;        
          }
        }
        if(t=='PISO'){
          if(!esBorradoFlechaTab && !esNumero && !esEnter){
            if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95 || e.key=="+" || e.charCode==43 ||
            e.key==":" || e.charCode==58 || e.key=="*" || e.charCode==42 || e.key=="P" || e.charCode==80 || e.key=="H" || e.charCode==72 )
              return true;
            else
              return false;        
          }
        }            
        if(t=='COORD'){
          if(!esBorradoFlechaTab && !esNumero && !esEnter){
            if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95)
              return true;
            else
              return false;        
          }
        }                
        if(t=='TEXTO' || t == 'PWD' || t == 'ID' || t == 'NOMBRE'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esAcentoMayuscula && !esAcentoMinuscula && !esEspacio && !esEnter){
            if( e.key== "$"    || e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key== "#"    || e.key=="@"     || e.key=="."     || e.key==","     || e.key==":"     || e.key==";"     || e.key=="*"     || e.key=="-"     || e.key=="%"     || e.key=="!"     || e.key=="?"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
             || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==58 || e.charCode==59 || e.charCode==42 || e.charCode==45 || e.charCode==37 || e.charCode==33 || e.charCode==63 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
               return true;
             else
               return false;
           }
        }
        if(t=='MAIL'){
          if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
            if(e.key=="." || e.charCode==46 ||  e.key=="+" || e.charCode==43 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95 ||  e.key=="@" || e.charCode==64)
              return true;
            else
              return false;
          }    
        }         
        if(t=='URL'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
             if( e.key== "$"    ||e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key=="#"     || e.key=="@"     || e.key=="."     || e.key==","     || e.key==":"     || e.key==";"     || e.key=="*"     || e.key=="-"     || e.key=="%"     || e.key=="!"     || e.key=="?"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
             || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==58 || e.charCode==59 || e.charCode==42 || e.charCode==45 || e.charCode==37 || e.charCode==33 || e.charCode==63 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
               return true;
             else
               return false;             
           }
        }
        if(t=='FILE'){
          if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esAcentoMayuscula && !esAcentoMinuscula && !esEspacio && !esEnter){
            if( e.key=="$"    || e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key== "#"    || e.key=="@"     || e.key=="."     || e.key==","     || e.key==";"     || e.key=="-"     || e.key=="!"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
            || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==59 || e.charCode==45 || e.charCode==33 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
              return true;
            else
              return false;            
          }
        }         
        return true;
 }

fnFileExist(path):Observable<string> {
  var para = [];
  var obj = {
      'path': path
  };
  para.push(obj);
  return this.http.post<string>(this.urlFnFileExist, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('fnFileExist'))
  );
}

isAlive():Observable<string> {
  return this.http.post<string>(this.urlAlive, '', httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('isAlive'))
  );
}

sendMail(f,m,u,n,h,pto,us,pw,ssl,tsl){
  var url = "";
  var para = [];
  var obj;  
  if (f=="RECUP"){
    obj =  {
      'm': m,
      'u': u,
      'n': n,
      'mailh': h,
      'mailpto': pto,
      'mailus': us,
      'mailssl': ssl,
      'mailtsl': tsl,
      'mailpw': pw,
      'sysn': this.sN,
      'syswe': this.sWe
    }    
    url = this.urlMailRec;
  }
  if (f=="PBA"){
    obj =  {
      'm': m,
      'mailh': h,
      'mailpto': pto,
      'mailus': us,
      'mailssl': ssl,
      'mailtsl': tsl,
      'mailpw': pw,
      'sysn': this.sN,
      'syswe': this.sWe
    }   
    url = this.urlMailPba;
  }
  if (f=="AVISO"){
    obj =  {
      'm': m,
      'html': u,
      'msg': n,
      'mailh': h,
      'mailpto': pto,
      'mailus': us,
      'mailssl': ssl,
      'mailtsl': tsl,
      'mailpw': pw,
      'sysn': this.sN,
      'syswe': this.sWe
    }   
    url = this.urlMailAviso;
  }
  if (f=="SINIES"){
    obj =  {
      'm': m
    }
    url = this.urlMailSinies;    
  }
  para.push(obj);
  return this.http.post<string>(url, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('sendMail'))
  );
}

downloadFile(folio, text){
  console.log(folio)
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', folio + ".xml");
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();

  document.body.removeChild(element);
}

getSatRegimen(tipo):Observable<string> {
  var para = [];
  var obj;
  obj =  {
    'tipo' : tipo
  }
  para.push(obj);
  return this.http.post<string>(this.urlSATRegimen, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatRegimen'))
  );  
}

getSatTipoFactura():Observable<string> {
  var para = [];
  return this.http.post<string>(this.urlSATTipoFactura, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatTipoFactura'))
  );  
}

getSatUso():Observable<string> {
  var para = [];
  return this.http.post<string>(this.urlSATUso, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatUso'))
  );  
}

getSatMoneda():Observable<string> {
  var para = [];
  return this.http.post<string>(this.urlSATMoneda, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatMoneda'))
  );  
}

getSatForma():Observable<string> {
  var para = [];
  return this.http.post<string>(this.urlSATForma, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatForma'))
  );  
}

getSatMetodo():Observable<string> {
  var para = [];
  return this.http.post<string>(this.urlSATMetodo, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getSatMetodo'))
  );  
}


getFormatoImp(mod, act):Observable<string> {
  var para = [];
  var obj;
  obj =  {
    'mod' : mod,
    'act' : act
  }
  para.push(obj);
  return this.http.post<string>(this.urlFormatoImp, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFormatoImp'))
  );
}

getFormatoFacturaImp(act):Observable<string> {
  var para = [];
  var obj;
  obj =  {
    'act' : act
  }
  para.push(obj);
  return this.http.post<string>(this.urlFormatoFacturaImp, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFormatoFacturaImp'))
  );
}

getElemFormatoImp(idForm, tipo, act):Observable<string> {
  var para = [];
  var obj;
  obj =  {
    'idForm' : idForm,
    'tipo' : tipo,
    'act' : act
  }
  para.push(obj);
  return this.http.post<string>(this.urlElemFormatoImp, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getElemFormatoImp'))
  );
}

getFormStyles(ids, act):Observable<string> {
  var para = [];
  var obj;
  obj =  {
    'ids' : ids,
    'act' : act
  }
  para.push(obj);
  return this.http.post<string>(this.urlFormStyles, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFormStyles'))
  );
}



getG():Observable<string> {
  return this.http.post<string>(this.urlG, '', httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getG'))
  );
}

getK(id):Observable<string> {
  var para = [];
  var obj =  {
    'id': id
  }
  para.push(obj);
  return this.http.post<string>(this.urlK, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getK'))
  );
}


getR():Observable<string> {
  return this.http.post<string>(this.urlR, '', httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getR'))
  );
}

getMail(a):Observable<string> {
  var para = [];
  var obj =  {
    'a': a
  }
  para.push(obj);
  return this.http.post<string>(this.urlMail, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getMail'))
  );
}

getMenu():Observable<string> {
  return this.http.post<string>(this.urlMenu, '', httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getMenu'))
  );
}

getMenu2():Observable<string> {
  return this.http.post<string>(this.urlMenu2, '', httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getMenu2'))
  );
}

getMenUser():Observable<string> {
  var r = sessionStorage.getItem('sisDVDusrR');
  var para = [];
  var obj =  {
    'r': r
  }
  para.push(obj);
  return this.http.post<string>(this.urlMenUser, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getMenUser'))
  );
}

getLogin(u,p):Observable<string> {
  var para = [];
  var obj =  {
    'u': u,
    'p': p
  }
  para.push(obj);
  return this.http.post<string>(this.urlLogin, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getLogin'))
  );
}

getValidaCto(bases, cto, monto):Observable<string> {
  var para = [];
  var obj =  {
    'bases': bases,
    'cto': cto,
    'monto': monto
  }
  para.push(obj);
  return this.http.post<string>(this.urlValidaCto, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getValidaCto'))
  );
}

getValidaCtoGes(cto, cveAct):Observable<string> {
  var para = [];
  var obj =  {
    'cto': cto,
    'cveAct': cveAct
  }
  para.push(obj);
  return this.http.post<string>(this.urlValidaCtoGes, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getValidaCtoGes'))
  );
}

getMsg(f,i):Observable<string> {
  var para = [];
  var obj =  {
    'id': i
  }
  para.push(obj);
  return this.http.post<string>(this.urlUsrExist, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getMsg'))
  );
}

gridUser(u):Observable<string> {
  var para = [];
  var obj =  {
    'u': u
  }
  para.push(obj);
  return this.http.post<string>(this.urlUsers, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('gridUser'))
  );
}

getUser(u):Observable<string> {
  var para = [];
  var obj =  {
    'u': u
  }
  para.push(obj);
  return this.http.post<string>(this.urlUser, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getUser'))
  );
}

getBases():Observable<string> {
  var para = [];
  var obj =  {
    'algo': 0
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetBases, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getBases'))
  );
}

getFinanciera(cto):Observable<string> {
  var para = [];
  var obj =  {
    'cto': cto
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetFinanciera, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFinanciera'))
  );
}
getGestoraGes(cto, idSuc):Observable<string> {
  var para = [];
  var obj =  {
    'cto': cto,
    'idSuc': idSuc
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetGestoraGes, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getGestoraGes'))
  );
}

getOrigenes(emp, cto):Observable<string> {
  var para = [];
  var obj =  {
    'emp': emp,
    'cto': cto
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetOrigenes, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getOrigenes'))
  );
}

getGenerales(emp, db, cto):Observable<string> {
  var para = [];
  var obj =  {
    'emp': emp,
    'db': db,
    'cto': cto
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetGenerales, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getGenerales'))
  );
}

getGeneralesGes(cto, idSuc):Observable<string> {
  var para = [];
  var obj =  {
    'idSuc': idSuc,
    'cto': cto
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetGeneralesGes, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getGeneralesGes'))
  );
}

getFolios(emp, db, cto):Observable<string> {
  var para = [];
  var obj =  {
    'emp': emp,
    'db': db,
    'cto': cto
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetFolios, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFolios'))
  );
}
getFoliosGes(cto, rfc):Observable<string> {
  var para = [];
  var obj =  {
    'cto': cto,
    'rfc': rfc
  }
  para.push(obj);
  return this.http.post<string>(this.urlGetFoliosGes, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('getFoliosGes'))
  );
}



/**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
private handleError<T> (operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {

    // TODO: send the error to remote logging infrastructure
    console.error(error); // log to console instead

    // TODO: better job of transforming error for user consumption
    this.log(`${operation} failed: ${error.message}`);

    // Let the app keep running by returning an empty result.
    return of(result as T);
  };
}

/** Log a DataService message */
private log(message: any) {
  //console.log(message);
}

}